/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_StrapiInputs */

const en_svchip_strapi = /** @type {(inputs: Svchip_StrapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strapi`)
};

const ar_svchip_strapi = /** @type {(inputs: Svchip_StrapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strapi`)
};

const bn_svchip_strapi = /** @type {(inputs: Svchip_StrapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strapi`)
};

const de_svchip_strapi = /** @type {(inputs: Svchip_StrapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strapi`)
};

const es_svchip_strapi = /** @type {(inputs: Svchip_StrapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correa`)
};

const fr_svchip_strapi = /** @type {(inputs: Svchip_StrapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strapi`)
};

const pt_svchip_strapi = /** @type {(inputs: Svchip_StrapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correia`)
};

const zh_svchip_strapi = /** @type {(inputs: Svchip_StrapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`皮带`)
};

const tr_svchip_strapi = /** @type {(inputs: Svchip_StrapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Askılı`)
};

const ru_svchip_strapi = /** @type {(inputs: Svchip_StrapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страпи`)
};

const pl_svchip_strapi = /** @type {(inputs: Svchip_StrapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasek`)
};

/**
* | output |
* | --- |
* | "Strapi" |
*
* @param {Svchip_StrapiInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_strapi = /** @type {((inputs?: Svchip_StrapiInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_StrapiInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_strapi(inputs)
	if (locale === "bn") return bn_svchip_strapi(inputs)
	if (locale === "de") return de_svchip_strapi(inputs)
	if (locale === "es") return es_svchip_strapi(inputs)
	if (locale === "fr") return fr_svchip_strapi(inputs)
	if (locale === "pt") return pt_svchip_strapi(inputs)
	if (locale === "zh") return zh_svchip_strapi(inputs)
	if (locale === "tr") return tr_svchip_strapi(inputs)
	if (locale === "ru") return ru_svchip_strapi(inputs)
	if (locale === "pl") return pl_svchip_strapi(inputs)
	return en_svchip_strapi(inputs)
});